import type { BuddyRequestItem } from "../lib/api/useEventBuddies";
import { ProfileImage } from "./ProfileImage";

export function BuddyAvatar({
  buddy,
  onClick,
}: {
  buddy: BuddyRequestItem;
  onClick: () => void;
}) {
  const accepted = buddy.acceptedApplicants;
  const hasGroup = accepted.length > 0;
  const visibleMembers = [buddy.user, ...accepted].slice(0, 4);
  const overflow = accepted.length - Math.min(accepted.length, 3);

  return (
    <button
      type="button"
      onClick={onClick}
      className="shrink-0 flex flex-col items-center gap-1.5 group focus:outline-none"
    >
      <div className="h-14 flex items-center justify-center relative">
        {hasGroup ? (
          <div className="flex items-center -space-x-2.5">
            {visibleMembers.map((u, i) => (
              <div
                key={u.id}
                className="ring-2 ring-white dark:ring-neutral-900 rounded-full group-hover:opacity-90 transition-opacity"
                style={{ position: "relative", zIndex: visibleMembers.length - i }}
              >
                <ProfileImage size="sm" user={u} />
              </div>
            ))}
            {overflow > 0 && (
              <div
                className="w-8 h-8 rounded-full ring-2 ring-white dark:ring-neutral-900 bg-neutral-100 dark:bg-neutral-800 flex items-center justify-center text-[10px] font-semibold text-neutral-500 dark:text-neutral-400"
                style={{ position: "relative", zIndex: 0 }}
              >
                +{overflow}
              </div>
            )}
          </div>
        ) : (
          <ProfileImage size="md" user={buddy.user} className="group-hover:opacity-90 transition-opacity" />
        )}
        {buddy.applied && (
          <span className="absolute bottom-0 right-0 w-3.5 h-3.5 rounded-full bg-primary-500 ring-2 ring-white dark:ring-neutral-900" />
        )}
      </div>
      <span className="text-[11px] text-neutral-600 dark:text-neutral-400 font-medium w-16 text-center leading-tight truncate">
        {buddy.user.firstName}
      </span>
    </button>
  );
}
